const orderActionTypes = {
  FETCH_GET_USER_ADDRESS: 'FETCH_GET_USER_ADDRESS',
  FETCH_GET_USER_ADDRESS_SUCCESS: 'FETCH_GET_USER_ADDRESS_SUCCESS',
  FETCH_GET_USER_ADDRESS_FAIL: 'FETCH_GET_USER_ADDRESS_FAIL',

  FETCH_ADD_USER_ADDRESS: 'FETCH_ADD_USER_ADDRESS',
  FETCH_ADD_USER_ADDRESS_SUCCESS: 'FETCH_ADD_USER_ADDRESS_SUCCESS',
  FETCH_ADD_USER_ADDRESS_FAIL: 'FETCH_ADD_USER_ADDRESS_FAIL',

  FETCH_SEARCH_PRODUCTS: 'FETCH_SEARCH_PRODUCTS',
  FETCH_SEARCH_PRODUCTS_SUCCESS: 'FETCH_SEARCH_PRODUCTS_SUCCESS',
  FETCH_SEARCH_PRODUCTS_FAIL: 'FETCH_SEARCH_PRODUCTS_FAIL',
  RESET_SEARCH_PRODUCTS: 'RESET_SEARCH_PRODUCTS',

  FETCH_SUBMIT_ORDER_BULK: 'FETCH_SUBMIT_ORDER_BULK',
  FETCH_SUBMIT_ORDER_BULK_SUCCESS: 'FETCH_SUBMIT_ORDER_BULK_SUCCESS',
  FETCH_SUBMIT_ORDER_BULK_FAIL: 'FETCH_SUBMIT_ORDER_BULK_FAIL',
};

export default orderActionTypes;
